export class Nationalite {
    idnationalite: number;
    nationalite: string;

    constructor({idnationalite = null, nationalite = null} = {}) {
        this.idnationalite = idnationalite;
        this.nationalite = nationalite;
    }
}
